import React from 'react';
import { Card, CardContent } from './ui/card';
import { Clock, DollarSign, Printer, FileCheck, Shield, Users, FolderOpen, Smartphone } from 'lucide-react';

const BenefitsSection = () => {
  const benefits = [
    {
      icon: <Clock className="h-10 w-10 text-pink-600" />,
      title: 'Instant Generation',
      description: 'Create professional, formatted certificates in under 2 minutes with zero design skills or technical knowledge required.'
    },
    {
      icon: <DollarSign className="h-10 w-10 text-pink-600" />,
      title: 'Completely Free',
      description: 'No hidden fees, subscriptions, or premium plans. Generate unlimited certificates without spending a single rupee.'
    },
    {
      icon: <Printer className="h-10 w-10 text-pink-600" />,
      title: 'Print & Share Ready',
      description: 'Download high-quality PDFs or PNG images instantly, ready for printing, email submission, or WhatsApp sharing.'
    },
    {
      icon: <FileCheck className="h-10 w-10 text-pink-600" />,
      title: 'Professional Templates',
      description: 'Authentic medical certificate formats with realistic layouts, proper medical terminology, and doctor-style presentation.'
    },
    {
      icon: <Shield className="h-10 w-10 text-pink-600" />,
      title: '100% Private',
      description: 'All processing happens in your browser. We never store, access, or transmit your personal or medical information.'
    },
    {
      icon: <Users className="h-10 w-10 text-pink-600" />,
      title: 'Multiple Use Cases',
      description: 'Perfect for doctors creating templates, HR documentation, students learning formats, and medical professionals streamlining work.'
    },
    {
      icon: <FolderOpen className="h-10 w-10 text-pink-600" />,
      title: 'Save & Restore',
      description: 'Certificate history feature lets you save and reload previous certificates with one click - no need to retype patient details.'
    },
    {
      icon: <Smartphone className="h-10 w-10 text-pink-600" />,
      title: 'Any Device',
      description: 'Fully responsive design works flawlessly on mobile phones, tablets, and desktops without any app installation needed.'
    }
  ];

  return (
    <div className="py-16 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-pink-600 font-semibold mb-2">Why Choose Our Tool</p>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Benefits of Using Our Medical Certificate Generator
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Streamline your workflow, maintain organization, and generate professional medical certificates in seconds — absolutely free with no sign-up required.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits.map((benefit) => (
            <Card key={benefit.title} className="text-center hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
              <CardContent className="pt-6 pb-6">
                <div className="flex justify-center mb-4">
                  {benefit.icon}
                </div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">{benefit.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed">{benefit.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BenefitsSection;
